import { UnifiedViewerNodeType } from '../types';

import findNearestAncestorByUnifiedViewerType from './findNearestAncestorByUnifiedViewerType';

export const findNearestAnnotationAncestor =
  findNearestAncestorByUnifiedViewerType(UnifiedViewerNodeType.ANNOTATION);

export default findNearestAnnotationAncestor;
